module.exports = __webpack_public_path__ + "f572638f/img/product-icon-grey.b248963c.svg";